'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidHand = function IoAndroidHand(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.3 21.4c1.2 1.2 1.4 2.8 0.3 4 0 0-7.5 8-9.9 9.4-2.2 1.7-5.1 2.7-7.8 2.7-4.3 0-7.9-2.8-9.1-6.6v-0.1c0-0.1-0.1-0.2-0.1-0.3l-4.5-14.7c-0.4-1.2 0.1-2.5 1.3-2.9s2.3 0.2 2.7 1.4l2.7 6.9c0.1 0.3 0.1 0.1 0.1-0.1l-1.7-12.6c-0.2-1.2 0.6-2.3 1.7-2.6s2.4 0.7 2.6 1.8l2 10.8c0 0.2 0.1 0.2 0.1 0v-13.8c0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2l0.6 13.7c0 0.3 0.3 0.3 0.3 0l1.8-10.5c0.2-1.2 1.3-2.1 2.4-2s2.2 1.4 2 2.5l-1.6 13.5c-0.1 0.9-0.3 2.3 0.1 2.8 0.6 0.7 1.6 0.7 2.4-0.2l3.3-3.2c1.2-1.2 2.8-1.1 3.9 0.1z' })
        )
    );
};

exports.default = IoAndroidHand;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-hand.js
// module id = 2348
// module chunks = 168707334958949